import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createGenerationSalesMaster,
  listBgMasters,
  listGenerationSalesMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 発電販売計画マスタ 新規登録 mutation hook。
 * onSuccess で listGenerationSalesMasters と listBgMasters (配下発電所数) を invalidate してテーブルを最新化する。
 */
export function useCreateGenerationSalesMaster(): InvalidatingMutationResultFor<
  typeof createGenerationSalesMaster
> {
  return useInvalidatingMutation(createGenerationSalesMaster, [
    createConnectQueryKey({
      schema: listGenerationSalesMasters,
      cardinality: 'finite',
    }),
    // BG 一覧の「配下発電所数」は発電販売計画マスタの発電所情報から導出されるので、BG タブ・CSV も取り直す
    createConnectQueryKey({
      schema: listBgMasters,
      cardinality: 'finite',
    }),
  ])
}
